var _rect, _path, _path2, _path3, _path4, _circle, _circle2, _circle3, _path5, _path6, _path7, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMembershipRibbonBig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105,
    height: 40,
    viewBox: "0 0 105 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 6,
    width: 102,
    height: 34,
    fill: "#155A9B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 6C42.7469 5.99197 64.7406 6.3987 101 0L105 33.0275C78.6344 39.633 44.4053 39.633 0 40V6Z",
    fill: "url(#paint0_linear_230_3563)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 26.1577L12.3107 20.0383C11.3657 19.0219 9.75 19.7417 9.75 21.1791L10.4375 31.9375L18 26.1577Z",
    fill: "#D1E7FC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 26.1577L23.6893 20.0383C24.6343 19.0219 26.25 19.7417 26.25 21.1791L25.5625 31.9375L18 26.1577Z",
    fill: "#8BC0F2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.607 17.355C17.1278 16.1241 18.8722 16.1241 19.393 17.355L25.5625 31.9375H10.4375L16.607 17.355Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26.25,
    cy: 17.5,
    r: 1.71875,
    fill: "#8BC0F2"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 14.0625,
    r: 1.71875,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.75,
    cy: 17.5,
    r: 1.71875,
    fill: "#D1E7FC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M94.4623 27.2217L79.2083 29.2122L78.1429 21.0481L81.6234 20.5939L81.8084 22.0119L90.1014 20.9297L89.9164 19.5117L93.3969 19.0575L94.4623 27.2217ZM87.5474 18.772L84.3892 19.1842L82.3526 14.7958L81.85 13.7907L81.6352 14.8239L80.1652 19.8009L76.3194 20.3028L79.322 10.4935L83.4041 9.96077L87.5474 18.772ZM93.3044 18.3485L89.8239 18.8027L88.5763 9.24213L92.0567 8.78794L93.3044 18.3485ZM90.6229 24.9258L90.4603 23.6797L82.1673 24.7619L82.3299 26.008L90.6229 24.9258Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4019 31.1866L56.793 12.7969L60.3997 12.4813L61.0113 19.4721L64.3508 19.1799L63.7411 12.2114L67.3478 11.8959L67.9439 18.7085L70.571 18.4787L69.973 11.6438L73.5797 11.3282L75.208 29.9405L71.6013 30.2561L70.867 21.8627L68.2399 22.0926L68.9548 30.2633L58.4019 31.1866ZM61.7398 27.7986L65.0793 27.5065L64.6196 22.2523L61.2801 22.5444L61.7398 27.7986Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5052 31.7793H38.4718V23.9576H54.5052V31.7793ZM37.4102 16.8076V13.2109H45.8602V16.1793H47.0302V13.2109H50.3235V23.1993H47.0302V19.0826H45.8602V22.8309H37.4102V19.2343V16.8076ZM54.5052 23.1993H51.2118V13.2109H54.5052V23.1993ZM41.9818 26.9476V28.7893H50.9952V26.9476H41.9818ZM42.5668 19.8409V16.2009H40.7035V19.8409H42.5668Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_230_3563",
    x1: -2.47033e-8,
    y1: 21.5,
    x2: 103.5,
    y2: 21.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1890FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#1573CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1890FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMembershipRibbonBig);
export default __webpack_public_path__ + "static/media/membership-ribbon-big.07098cbe850ca16b69ac829b1def5262.svg";
export { ForwardRef as ReactComponent };